export default {
  xs: {
    minWidth: 375,
  },
  sm: {
    minWidth: 576,
  },
  md: {
    minWidth: 768,
  },
  lg: {
    minWidth: 992,
  },
  xl: {
    minWidth: 1200,
  },
};
